import CC from "components/Stacker/constants/CartConstants"
import AC from "components/Stacker/constants/AddressConstants"
import PCC from "components/Stacker/constants/PromoCodeConstants"
import GCC from "components/Stacker/constants/GiftCardConstants"
import GMC from "components/Stacker/constants/GiftMessageConstants"
import PPC from "components/Stacker/constants/PaypalConstants"
import PDC from "components/Stacker/constants/ProductDetailPageConstants"
import SWC from "components/Stacker/constants/SwatchConstants"
import PC from "components/Stacker/constants/PaymentConstants"
import ASMC from "components/Stacker/constants/AsmConstants"
import RM from "components/Stacker/constants/ReferralNumberConstants"

import getValue from "object-getvalue"
import { getDY_SR } from "stackerConfig"

export const initialState = {
  meta: {
    isDataLoading: false,
    isError: false,
    message: "",
    isNoResultView: false,
    isCheckoutInProgress: false,
    isCodeVerificationInProgress: false,
    isPromoRemovalInProgress: false,
    isVoucherRemovalInProgress: false,
    isPromoError: false,
    giftMessageToggle: {},
    giftMessageSaving: {},
    giftMessageRemoving: {},
    isReferralNumberVerificationInProgress: false,
    isReferralNumberRemovalInProgress: false,
    isReferralNumberError: false,
  },
  data: {
    entries: [],
    cartTotal: "$0",
    cartID: "",
    promotions: [],
    referralNumbers: [],
    appliedVouchers: [],
    pageInfo: {},
    shoppingCartView: {},
  },
  promoCart: {
    promoTitleText: getValue(
      { DY_SR: getDY_SR() },
      "DY_SR.data.shoppingBag.promoCart.promoTitleText",
      null
    ),
    promoDescriptionText: getValue(
      { DY_SR: getDY_SR() },
      "DY_SR.data.shoppingBag.promoCart.promoDescriptionText",
      null
    ),
    promoImageURL: getValue(
      { DY_SR: getDY_SR() },
      "DY_SR.data.shoppingBag.promoCart.promoImageURL",
      null
    ),
    promoLinkText: getValue(
      { DY_SR: getDY_SR() },
      "DY_SR.data.shoppingBag.promoCart.promoLinkText",
      null
    ),
  },
  isShowMiniBag: false, // This flag is required to show Mini Bag for 3 seconds
  isAPICallRequired: true, // To avoid any call on hover if no changes are done
  deletedProductList: [],
  editEntries: {}, // object with key being the entryNumber and value being the PDP pid
}

export default function cartReducer(previousState = initialState, action) {
  let newState

  switch (action.type) {
    case CC.CART_DETAILS_STARTED:
      newState = {
        ...previousState,
        meta: {
          ...previousState.meta,
          message: initialState.meta.message,
          isDataLoading: getValue(action, "payload"),
        },
      }
      return newState

    case AC.ADDRESS_VALIDATED:
    case CC.CART_DETAILS_FETCHED:
    case ASMC.FIND_ASM_USER_CART_SUCCESS:
    case ASMC.ASM_OVERRIDE_CART_PRICE_SUCCESS:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isDataLoading: false,
          isError: false,
          isNoResultView: false,
          message: initialState.meta.message,
        },
        data: { ...previousState.data, ...action.payload.res },

        isShowMiniBag: getValue(action, "payload.options.addToCart", false), //  Show Mini Bag Automatically [3 sec] for Add To Cart call
        isAPICallRequired: false,
      }

    case CC.CART_DETAILS_FAILED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isDataLoading: false,
          isError: true,
          isNoResultView: false,
          message: action.payload,
          pid: action.pid,
        },
        isShowMiniBag: false,
        isAPICallRequired: true, // if Failed, allow the API call
      }

    case CC.CART_RESET_ADD_TO_CART_FLAG:
      return {
        ...previousState,
        isAPICallRequired: initialState.isAPICallRequired,
      }

    case CC.CART_RESET_DISPLAY_CART_FLAG:
      return {
        ...previousState,
        isShowMiniBag: initialState.isShowMiniBag,
      }

    case CC.CART_RESET_REMOVED_PRODUCT_LIST:
      return {
        ...previousState,
        deletedProductList: initialState.deletedProductList,
      }

    case CC.CART_ADD_TO_REMOVED_PRODUCT_LIST: {
      const currentEntryId = action.payload.entryNumber
      const prevEditEntries = previousState.editEntries

      delete prevEditEntries[currentEntryId]
      return {
        ...previousState,
        deletedProductList: [
          ...previousState.deletedProductList,
          action.payload,
        ],
        editEntries: {
          ...prevEditEntries,
        },
      }
    }

    case CC.CART_DELETE_FROM_REMOVED_PRODUCT_LIST:
      return {
        ...previousState,
        deletedProductList: previousState.deletedProductList.filter(
          (item) => action.payload.product !== item.product
        ),
      }

    case CC.CART_RESET_OUT_OF_STOCK_LIST:
      return {
        ...previousState,
        outOfStockEntries: initialState.outOfStockEntries,
      }

    case CC.CART_CHECKOUT_STARTED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isCheckoutInProgress: true,
        },
      }

    case CC.CART_CHECKOUT_SUCCESS:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isCheckoutInProgress: false,
        },
        data: action.payload,
      }

    case CC.CART_CHECKOUT_FAILED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isCheckoutInProgress: false,
        },
      }

    // Promo Code action handlers
    case PCC.PROMO_VOUCHER_CODE_ADD_STARTED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isCodeVerificationInProgress: true,
        },
      }

    case PCC.PROMO_VOUCHER_CODE_ADD_SUCCESS:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isCodeVerificationInProgress:
            initialState.meta.isCodeVerificationInProgress,
          isPromoError: initialState.meta.isPromoError,
        },
        data: {
          ...previousState.data,
          ...action.payload,
        },
      }

    case PCC.PROMO_VOUCHER_CODE_ADD_FAILED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isCodeVerificationInProgress:
            initialState.meta.isCodeVerificationInProgress,
          isPromoError: true,
        },
      }

    case PCC.PROMO_RESET_ERR:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isPromoError: false,
        },
      }

    case PCC.PROMO_CODE_REMOVE_STARTED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isPromoRemovalInProgress: true,
        },
      }

    case PCC.PROMO_VOUCHER_REMOVE_STARTED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isVoucherRemovalInProgress: true,
        },
      }

    case PCC.PROMO_CODE_REMOVE_SUCCESS:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isPromoRemovalInProgress: initialState.meta.isPromoRemovalInProgress,
        },
        data: {
          ...previousState.data,
          ...action.payload,
        },
      }

    case PCC.PROMO_VOUCHER_REMOVE_SUCCESS:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isVoucherRemovalInProgress:
            initialState.meta.isVoucherRemovalInProgress,
        },
        data: {
          ...previousState.data,
          ...action.payload,
        },
      }

    case PCC.PROMO_CODE_REMOVE_FAILED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isPromoRemovalInProgress: initialState.meta.isPromoRemovalInProgress,
        },
      }

    case PCC.PROMO_VOUCHER_REMOVE_FAILED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isVoucherRemovalInProgress:
            initialState.meta.isVoucherRemovalInProgress,
        },
      }

    // Referral Number action handlers
    case RM.REFERRAL_NUMBER_ADD_STARTED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isReferralNumberVerificationInProgress: true,
        },
      }

    case RM.REFERRAL_NUMBER_ADD_SUCCESS:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isReferralNumberVerificationInProgress:
            initialState.meta.isReferralNumberVerificationInProgress,
          isReferralNumberError: initialState.meta.isReferralNumberError,
        },
        data: {
          ...previousState.data,
          referralNumbers: action.payload,
        },
      }

    case RM.REFERRAL_NUMBER_ADD_FAILED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isReferralNumberVerificationInProgress:
            initialState.meta.isReferralNumberVerificationInProgress,
          isReferralNumberError: true,
        },
        data: {
          ...previousState.data,
          failedReferralNumbers: action.payload,
        },
      }

    case RM.REFERRAL_NUMBER_RESET_ERR:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isPromoError: false,
        },
      }

    case RM.REFERRAL_NUMBER_REMOVE_STARTED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isPromoRemovalInProgress: true,
        },
      }

    case RM.REFERRAL_NUMBER_REMOVE_SUCCESS:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isReferralNumberRemovalInProgress:
            initialState.meta.isReferralNumberRemovalInProgress,
        },
        data: {
          ...previousState.data,
          referralNumbers: action.payload,
        },
      }

    case RM.REFERRAL_NUMBER_REMOVE_FAILED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isReferralNumberRemovalInProgress:
            initialState.meta.isReferralNumberRemovalInProgress,
        },
      }
    case RM.REFERRAL_NUMBER_CLEAR_REFERRAL_NUMBER:
      console.log(
        "initialState.data.referralNumbers: ",
        initialState.data.referralNumbers
      )
      return {
        ...previousState,
        data: {
          ...previousState.data,
          referralNumbers: initialState.data.referralNumbers,
        },
      }
    case GCC.GIFT_CARD_PAYMENT_SUCCESS:
      return {
        ...previousState,
        data: {
          ...previousState.data,
          ...action.payload,
        },
      }

    case GCC.GIFT_CARD_REMOVE_SUCCESS:
      return {
        ...previousState,
        data: {
          ...previousState.data,
          ...action.payload,
        },
      }

    // Gift Message action handlers

    case GMC.GIFT_MESSAGE_SAVE_STARTED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          giftMessageSaving: { [action.payload]: true },
        },
      }

    case GMC.GIFT_MESSAGE_SAVE_SUCCESS: {
      const {
        payload: { product, recipient, message },
      } = action
      const newSEntries = previousState.data.entries.map((entry) => {
        if (entry.product === product) {
          entry.giftMessage = { recipient, message }
        }
        return entry
      })
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          giftMessageSaving: { [product]: false },
          giftMessageToggle: { [product]: false },
        },
        data: {
          ...previousState.data,
          entries: newSEntries,
        },
      }
    }

    case GMC.GIFT_MESSAGE_SAVE_FAILED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          giftMessageSaving: { [action.payload]: false },
        },
      }

    case GMC.GIFT_MESSAGE_REMOVE_STARTED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          giftMessageRemoving: { [action.payload]: true },
        },
      }

    case GMC.GIFT_MESSAGE_REMOVE_SUCCESS: {
      const newREntries = previousState.data.entries.map((entry) => {
        if (entry.product === action.payload.product) {
          entry.giftMessage = null
        }
        return entry
      })
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          giftMessageRemoving: { [action.payload.product]: false },
          giftMessageToggle: { [action.payload.product]: false },
        },
        data: {
          ...previousState.data,
          entries: newREntries,
        },
      }
    }

    case GMC.GIFT_MESSAGE_REMOVE_FAILED:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          giftMessageRemoving: { [action.payload]: false },
        },
      }

    case GMC.GIFT_MESSAGE_EDIT:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          giftMessageToggle: { [action.payload]: true },
        },
      }
    case PPC.PAYPAL_EXPRESS_CHECKOUT_DELETE_SUCCESS:
      return {
        ...previousState,
        data: {
          ...previousState.data,
          payPalOrder: false,
        },
      }
    case CC.CART_EDIT_STARTED: {
      const { entry: id } = action.payload
      return {
        ...previousState,
        editEntries: {
          ...previousState.editEntries,
          [id]: {
            ...previousState.editEntries[id],
            showLoader: true,
          },
        },
      }
    }
    case CC.CART_TOGGLE_EDIT_ENTRY: {
      const currentEditEntry = action.payload
      const editEntryPreviousState = previousState.editEntries[currentEditEntry]

      return {
        ...previousState,
        editEntries: {
          ...previousState.editEntries,
          [currentEditEntry]: {
            ...editEntryPreviousState,
            isEditing: editEntryPreviousState
              ? !editEntryPreviousState.isEditing
              : true,
            isError: false,
            showLoader: false,
          },
        },
      }
    }
    case CC.CART_SET_EDIT_ENTRY: {
      const {
        entryNumber,
        baseProductID,
        selectedQuantity = 1,
      } = action.payload
      return {
        ...previousState,
        editEntries: {
          ...previousState.editEntries,
          [entryNumber]: {
            ...previousState.editEntries[entryNumber],
            pid: baseProductID.toUpperCase(),
            quantity: selectedQuantity,
            isError: false,
            showLoader: false,
          },
        },
      }
    }

    case CC.CART_UPPATE_EDIT_ENTRY_QUANTITY: {
      const { entryNumber: currentEnrtyNumber, qtyLabel } = action.payload
      return {
        ...previousState,
        editEntries: {
          ...previousState.editEntries,
          [currentEnrtyNumber]: {
            ...previousState.editEntries[currentEnrtyNumber],
            quantity: qtyLabel,
            isError: false,
            showLoader: false,
          },
        },
      }
    }

    case PDC.SET_SELECTED_SIZE:
    case SWC.SWATCH_SELECTED: {
      const {
        isEditCart,
        entryNumber: cartEntry,
        selectedQuantity: initialQtyValue = 1,
      } = action.payload
      if (isEditCart) {
        return {
          ...previousState,
          editEntries: {
            ...previousState.editEntries,
            [cartEntry]: {
              ...previousState.editEntries[cartEntry],
              quantity: initialQtyValue,
              isError: false,
              showLoader: false,
            },
          },
        }
      }
      return previousState
    }
    case CC.CART_SET_EDIT_ENTRY_ERROR: {
      const { entryNumber: entryId, errorMessage } = action.payload
      return {
        ...previousState,
        editEntries: {
          ...previousState.editEntries,
          [entryId]: {
            ...previousState.editEntries[entryId],
            isError: true,
            errorMessage,
            showLoader: false,
          },
        },
      }
    }

    case CC.CART_EDIT_SUCCESSFULL: {
      const { entry: currentEntry } = action.payload

      return {
        ...previousState,
        editEntries: {
          ...previousState.editEntries,
          [currentEntry]: {
            ...previousState.editEntries[currentEntry],
            isEditing: false,
            isError: false,
            showLoader: false,
          },
        },
      }
    }

    case CC.CART_EDIT_FAILED: {
      const { entry: entryID, error } = action.payload

      return {
        ...previousState,
        editEntries: {
          ...previousState.editEntries,
          [entryID]: {
            ...previousState.editEntries[entryID],
            isError: true,
            errorMessage: error,
            showLoader: false,
          },
        },
      }
    }

    case PC.AP_SHIPPING_CONTACT_SELECTED: {
      const { totalTax } = action.payload

      return {
        ...previousState,
        applePaySheetTaxAmount: totalTax ? totalTax.value : "",
      }
    }
    case CC.CART_RESET_ERROR:
      return {
        ...previousState,
        meta: {
          ...previousState.meta,
          isError: false,
          message: initialState.meta.message,
          pid: undefined,
        },
      }
    default:
      return previousState
  }
}
